<template>
  <div>
    <el-tabs type="border-card" v-model="activeName">
      <el-tab-pane :label="$t('makeSchedule.mfgWuJianInfoEdit.wujianEdit')" name="wuJianInfoEdit1">
        <MfgWuJianInfoEdit1 :setting="settingData" :parentData="formData" v-if="this.activeName === 'wuJianInfoEdit1'"></MfgWuJianInfoEdit1>
      </el-tab-pane>
      <el-tab-pane label="隐藏楼面单元" name="wuJianInfoEdit2">
        <MfgWuJianInfoEdit2 :setting="settingData" :parentData="formData" v-if="this.activeName === 'wuJianInfoEdit2'"></MfgWuJianInfoEdit2>
      </el-tab-pane>
    </el-tabs>
  </div>

</template>

<script>
import MfgWuJianInfoEdit1 from "@/views/applications/bus/make_schedule/MfgWuJianInfoEdit1";
import MfgWuJianInfoEdit2 from "@/views/applications/bus/make_schedule/MfgWuJianInfoEdit2";
export default {
  name: "MfgWuJianInfoEdit",
  components:{MfgWuJianInfoEdit2, MfgWuJianInfoEdit1},
  props: {
    setting: {
      type: Object,
      default: () => {
        return {}
      }
    },
    parentData: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  data(){
    return{
      settingData: this.setting,
      formData: this.parentData,
      activeName: 'wuJianInfoEdit1'
    }
  },
}
</script>

<style scoped>

</style>